import React, {useState} from 'react';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import SuburbTypeahead from '../SuburbTypeahead/SuburbTypeahead';
import {getStateBySuburbWithPostCode, getSuburbMarketId} from '../../selectors/suburbProperty';
import {allWords, titleCase} from '../../lib/urlTools';
import styles from './Members.scss';
import {deleteMarketWatch, doUnsubscribe, saveMarketWatch} from '../../actions';
import TrackReasonsModal from '../Modal/TrackReasonsModal/TrackReasonsModal';
import {displayErrorNotification} from '../../lib/toastNotifications';
import SimpleTrackItem from './SimpleTrackItem';

const TrackedSuburbs = (props) => {
    
  const { saveMarketWatch, markets, deleteMarketWatch } = props;
  
  const [showTrackModal, setShowTrackModal] = useState(false);
  const [suburbToTrack, setSuburbToTrack] = useState({});
  let hasMarkets = (markets && markets.subscribedSuburbs && markets.subscribedSuburbs.length > 0);

  const handleShowTrackModal = () => {
    setShowTrackModal(!showTrackModal);
  };

  const untrackSuburb = (marketId) => {
    deleteMarketWatch({marketId});
  };

  const handleSelectSuburbSearch = (suburb) => {
    const marketId = getSuburbMarketId(suburb);

    let alreadySubscribed = false;

    if(hasMarkets) {
      markets.subscribedSuburbs.find(subscribedSuburb => {
        if(subscribedSuburb.marketId === marketId) {
          alreadySubscribed = true;
        }
      });
    }

    if (alreadySubscribed) {
      displayErrorNotification('This suburb is already tracked.');
    } else {
      setShowTrackModal(!showTrackModal);
      setSuburbToTrack(suburb);
    }
  };

  const handleTrackSuburbSubmit = (selectedReason) => {
    const marketId = getSuburbMarketId(suburbToTrack);
    saveMarketWatch({
      marketId: marketId,
      subscribedMarketReason: selectedReason
    });
    handleShowTrackModal();
  };

  const prettyMarket = (suburb) => {
    let s = suburb.split('+');
    let postcode = s.pop();
    let suburbName = s.join(' ');
    return suburbName.replace(allWords, titleCase) + ' ' + postcode;
  };

  return (
    <div className={`mt-5 ${styles.TrackSuburbContainer}`}>
      <div className="d-flex justify-content-between">
        <h3 className="mb-2">Tracked Suburbs</h3>
      </div>
      <p className="mb-4">Monthly email updates for saved suburbs market trends, including median values and{' '}
            sold data, plus a snapshot of properties currently listed on the market.</p>
      <div>
        <SuburbTypeahead destination="function" returnFunction={handleSelectSuburbSearch} size="marketWatch" placeholder="Search for suburb" isTrackedSuburbPage={true} />
      </div>

      <div className={`mt-4 mb-5 ${styles.trackSuburbList}`}>
        {hasMarkets ?
          markets.subscribedSuburbs.map((market) => (
            <SimpleTrackItem
              key={market.marketId}
              isPropertyUntrackModal={false}
              linkName={prettyMarket(market.marketId)}
              linkSrc={`/suburb/${getStateBySuburbWithPostCode(prettyMarket(market.marketId))}/${market.marketId.toLowerCase().replaceAll('-','--').replaceAll('+','-')}`}
              untrack={() => untrackSuburb(market.marketId)}
            />
          ))
          :
          <div className={`rounded mb-4 ${styles.noSuburbDiv}`}>
            <img src="/assets/images/no-suburb-image.png"/>
            <div>
              <h3>Track your favourite Suburbs</h3>
              <p>Keep informed about your saved suburbs with a monthly digest. Get started by adding{' '}
                a suburb using the input field above.</p>
            </div>
          </div>
        }
      </div>
      {showTrackModal && <TrackReasonsModal
        showModal={showTrackModal}
        handleShowModalChange={handleShowTrackModal}
        handleTrackSubmit={(selectedReason) => handleTrackSuburbSubmit(selectedReason)}/>}
    </div>
  );
  
};

TrackedSuburbs.propTypes = {
  saveMarketWatch: PropTypes.func,
  deleteMarketWatch: PropTypes.func,
  markets: PropTypes.object
};

const mapStateToProps = (state) => {
  return {markets: state.marketWatch, userId: state.user.currentUser.uuid};
};
const mapDispatchToProps = {
  saveMarketWatch,
  deleteMarketWatch,
  doUnsubscribe,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackedSuburbs);